import React from 'react';
import { Button } from '@mui/material';

/**
 * Skip to main content link for keyboard navigation
 * Appears only when focused via keyboard (Tab key)
 */
const SkipToContent: React.FC = () => {
  const handleSkip = () => {
    const mainContent = document.getElementById('main-content');
    if (mainContent) {
      mainContent.focus();
      mainContent.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <Button
      onClick={handleSkip}
      sx={{
        position: 'absolute',
        left: '-9999px',
        zIndex: 9999,
        padding: '8px 16px',
        backgroundColor: 'primary.main',
        color: 'primary.contrastText',
        '&:focus': {
          left: '16px',
          top: '16px',
        },
      }}
    >
      Skip to main content
    </Button>
  );
};

export default SkipToContent;
